import React from "react";
import propTypes from "prop-types";
import { Marker, Pane } from "react-leaflet";
import { IconTarget } from "./icons";
import MarkersImbFtth from "./MarkersImbFtth";
import MarkersImbFtthVN from "./MarkersImbFtthVN";
import MarkersImbFtte from "./MarkersImbFtte";
import MarkersImbFtteVN from "./MarkersImbFtteVN";

const MarkersImb = ({
  dsp,
  imbWkt,
  marcheList,
  positionMarkerTarget,
  optionSelectedConfigCarte,
  zoom,
  isMobileLandscape,
  displayMarkerImb,
  ZOOM_LEVEL_IMB,
  ZOOM_LEVEL_FTTE,
  setChargementIMBWtk,
  onMarkerImbClick,
  onOperatorPopupClick,
  rechercheParSiret,
}) => (
  <>
    {/* Marker de position */}
    {positionMarkerTarget && (
      <Marker position={positionMarkerTarget} icon={IconTarget} zIndexOffset={1000} />
    )}
    <Pane name="markersImb" className="leaflet-markersImb-pane">
      {/* Marker FFTH */}
      {zoom >= ZOOM_LEVEL_IMB &&
        (optionSelectedConfigCarte.IMB_RAC ||
          optionSelectedConfigCarte.IMB_ELIG ||
          optionSelectedConfigCarte.IMB_PROELIG ||
          optionSelectedConfigCarte.IMB_TRAVAUX_RUE ||
          optionSelectedConfigCarte.IMB_TRAVAUX_SECTEUR ||
          optionSelectedConfigCarte.IMB_ETUDE ||
          optionSelectedConfigCarte.IMB_DEMANDE ||
          optionSelectedConfigCarte.IMB_BLOC_COLLECTIF_TIERS) && (
          <>
            {dsp.codeReseau !== "AI-VENU" ? (
              <MarkersImbFtth
                dsp={dsp}
                imbWkt={imbWkt}
                marcheList={marcheList}
                optionSelectedConfigCarte={optionSelectedConfigCarte}
                isMobileLandscape={isMobileLandscape}
                displayMarkerImb={displayMarkerImb}
                setChargementIMBWtk={setChargementIMBWtk}
                onMarkerImbClick={onMarkerImbClick}
                onOperatorPopupClick={onOperatorPopupClick}
              />
            ) : (
              <MarkersImbFtthVN
                dsp={dsp}
                imbWkt={imbWkt}
                optionSelectedConfigCarte={optionSelectedConfigCarte}
                displayMarkerImb={displayMarkerImb}
                setChargementIMBWtk={setChargementIMBWtk}
                onMarkerImbClick={onMarkerImbClick}
                onOperatorPopupClick={onOperatorPopupClick}
              />
            )}
          </>
        )}
      {/* Marker FFTE */}
      {zoom >= ZOOM_LEVEL_FTTE && optionSelectedConfigCarte.FTTE && (
        <>
          {dsp.codeReseau !== "AI-VENU" ? (
            <MarkersImbFtte
              dsp={dsp}
              imbWkt={imbWkt}
              displayMarkerImb={displayMarkerImb}
              setChargementIMBWtk={setChargementIMBWtk}
              onMarkerImbClick={onMarkerImbClick}
              rechercheParSiret={rechercheParSiret}
            />
          ) : (
            <MarkersImbFtteVN dsp={dsp} imbWkt={imbWkt} setChargementIMBWtk={setChargementIMBWtk} />
          )}
        </>
      )}
    </Pane>
  </>
);

MarkersImb.defaultProps = {
  positionMarkerTarget: null,
};

MarkersImb.propTypes = {
  dsp: propTypes.shape({
    logo: propTypes.string,
    codeMarche: propTypes.string,
    codeReseau: propTypes.string,
    libelle: propTypes.string,
    urlSite: propTypes.string,
    urlZonesDeploiement: propTypes.string,
    urlFibreFtth: propTypes.string,
    urlFibreSurDemande: propTypes.string,
    urlFibreFtte: propTypes.string,
    urlChangementAdresse: propTypes.string,
    urlListeOperateur: propTypes.string,
    urlPreparation: propTypes.string,
  }).isRequired,
  imbWkt: propTypes.shape({
    minLatLng: propTypes.shape({
      lat: propTypes.number,
      lng: propTypes.number,
    }),
    maxLatLng: propTypes.shape({
      lat: propTypes.number,
      lng: propTypes.number,
    }),
  }).isRequired,
  marcheList: propTypes.array.isRequired,
  positionMarkerTarget: propTypes.arrayOf(propTypes.number),
  optionSelectedConfigCarte: propTypes.shape({
    LAYER_PLAN: propTypes.bool,
    LAYER_SAT: propTypes.bool,
    ALL_ZONES: propTypes.bool,
    SRO_DEP_201820: propTypes.bool,
    SRO_DEP_2021: propTypes.bool,
    SRO_DEP_2022: propTypes.bool,
    SRO_DEP_2023: propTypes.bool,
    SRO_OPEN: propTypes.bool,
    SRO_SOON: propTypes.bool,
    SRO_YEAR_N0: propTypes.bool,
    SRO_YEAR_N1: propTypes.bool,
    SRO_YEAR_N2: propTypes.bool,
    ZONE_RADIO: propTypes.bool,
    ZONE_AMII: propTypes.bool,
    ALL_STATUSES: propTypes.bool,
    IMB_RAC: propTypes.bool,
    IMB_ELIG: propTypes.bool,
    IMB_PROELIG: propTypes.bool,
    IMB_ETUDE: propTypes.bool,
    IMB_TRAVAUX_SECTEUR: propTypes.bool,
    IMB_TRAVAUX_RUE: propTypes.bool,
    IMB_DEMANDE: propTypes.bool,
    IMB_BLOC_COLLECTIF_TIERS: propTypes.bool,
    FTTE: propTypes.bool,
  }).isRequired,
  zoom: propTypes.number.isRequired,
  isMobileLandscape: propTypes.bool.isRequired,
  displayMarkerImb: propTypes.bool.isRequired,
  ZOOM_LEVEL_IMB: propTypes.number.isRequired,
  ZOOM_LEVEL_FTTE: propTypes.number.isRequired,
  setChargementIMBWtk: propTypes.func.isRequired,
  onMarkerImbClick: propTypes.func.isRequired,
  onOperatorPopupClick: propTypes.func.isRequired,
  rechercheParSiret: propTypes.func.isRequired,
};

export default MarkersImb;
